import React from "react";

function Loader() {
  return (
    <div className="w-screen mt-auto loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
}

export default Loader;
